<template>
  <div class="h-screen">
    <div class="flex h-screen items-center">
      <div class="flex flex-col h-full w-full md:w-1/2">
        <div class="block md:hidden w-full">
          <!-- Use 25% vertical alignment so the main subject stays visible in this short (h-56) mobile header crop -->
          <img
            class="w-full h-56 object-cover object-[center_25%] rounded-b-[40px]"
            alt="Dashboard Sign In"
            :src="welcomeImageUrl"
          />
        </div>

        <div class="flex justify-center items-center flex-1 md:h-[85%]">
          <div class="h-auto pb-2 w-96">
            <div class="h-full">
              <div class="px-4 m-0">
                <img class="w-[84px] mt-4" :src="LogoImage" />
                <div class="card-style" title="Sign In">
                  <slot />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hidden px-3 py-8 md:p-4 md:flex flex-col md:flex-row justify-between w-full self-end">
          <div class="">
            <p class="text-sm flex flex-row justify-center items-center text-gray-700">
              &copy; LayUp Technologies {{ new Date().getFullYear() }}
            </p>
          </div>
          <div class="flex flex-col lg:flex-row lg:gap-6 items-center">
            <a href="mailto:support@layup.co.za" class="text-sm flex flex-row justify-center items-center text-gray-700"
              ><img src="@/assets/icons/envelope.svg" class="w-4 mr-2" />support@layup.co.za</a
            >
            <a href="tel:+27870945555" class="text-sm flex flex-row justify-center items-center text-gray-700"
              ><img src="@/assets/icons/phone.svg" class="w-4 mr-2" />+27 87 094 5555</a
            >
          </div>
        </div>
      </div>
      <div class="hidden md:block w-1/2 h-full">
        <img class="w-full h-full object-cover rounded-s-[80px]" alt="Dashboard Sign In" :src="welcomeImageUrl" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LogoImage from '../assets/logo.svg';

const welcomeImageUrl = 'https://res.cloudinary.com/layup/image/upload/v1723647850/shopper-user-banner_f8byth.jpg';
</script>

<style scoped lang="scss">
@use '@/styling/global.scss' as *;

.backBtn {
  font-size: 20px;
  position: relative !important;
  top: 30px !important;
}
span.text-left {
  display: none;
}
@media only screen and (max-width: $bp-mobile) {
  span.text-left {
    display: block;
    top: 5%;
    position: absolute;
  }
}
</style>
